import { type ComponentProps, type MouseEventHandler, useState } from 'react'
import type { Menu } from './generic.tsx'

export const useMenu = () => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
	const openMenu: MouseEventHandler<HTMLElement> = (event) => setAnchorEl(event.currentTarget)
	const closeMenu = (e?: object) => {
		// Closing the menu by clicking outside seems to cause a "click" event on the menu
		// which propagates to parent element, which is not intended
		const isEvent = (e: object): e is Event => 'stopPropagation' in e
		if (e && isEvent(e)) {
			e.stopPropagation()
		}

		setAnchorEl(null)
	}
	return {
		menuProps: { anchorEl, open: Boolean(anchorEl), onClose: closeMenu } satisfies ComponentProps<typeof Menu>,
		openMenu,
		closeMenu,
	}
}
